import React, { memo } from "react";

const TaskIcon = memo(({ type }) => {
    if (type === "Unassign Task" || type === "Task List") {
        return <span>👤</span>;
    }

    if (type === "Task Planner") {
        return <span>🤖</span>;
    }

    if (type === "Workflow") {
        return <span>⚙️</span>;
    }

    if (type === "Chat Task") {
        return <span>💬</span>;
    }

    if (type === "Meeting Task") {
        return <span>📹</span>;
    }

    return null;
});

export default TaskIcon;
